import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './ConfiguratorButton.styles'
import Button from '@material-ui/core/Button'
import LINKS from '../../../App.const'
import { useHistory } from 'react-router'
import SettingsIcon from '@material-ui/icons/Settings'

const useStyles = makeStyles(styles, { name: 'ConfiguratorButton' })

function ConfiguratorButton () {
  const classes = useStyles()

  const history = useHistory()

  const config = () => {
    history.push(LINKS.MAIN.CONFIGURATOR.path)
  }

  return (
    <Button className={classes.main} onClick={config}>
      <SettingsIcon />
    </Button>
  )
}

export default ConfiguratorButton
